<div class="consumer-layout">
  <header [ngClass]="{ 'menu-opened': isOpened }">
    <div class="container-fluid">
      <div class="header-wrapper-content">
        <div class="logo-container">
          <img src="../assets/images/logos/cpa-logo.png" alt="" />
        </div>

        <div class="menu-container">
          <button class="nav-btn" [ngClass]="{ open: isOpened }" (click)="isOpened = !isOpened">
            <i></i><i></i><i></i>
          </button>
          <ul class="nav mr-auto" data-aos="fade-up" data-aos-delay="200">
            <ng-container *ngIf="currentUser">
              <li>
                <a [routerLink]="['/']" routerLinkActive="active">
                  {{'header.rightsAndDutiesGuide' | translate}}
                </a>
              </li>

              <li class="nav-item userAccount dropdown-container elementor-widget-container position-relative"
                appDropDown>
                <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">
                  {{'header.storeReports' | translate}}
                </a>
                <ul class="custom-dropdown-menu dropdown-menu-left dropdown-inner-menu">
                  <li>
                    <a [routerLink]="['/reports/online-stores']">
                      {{ 'header.ecommerceTrustReports' | translate }}
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/reports/physical-stores']">
                      {{ 'header.physicalStoreTrustReports' | translate }}
                    </a>
                  </li>
                </ul>
              </li>
              <!-- <li>
              <a [routerLink]="['/link2']" routerLinkActive="active">
                {{'header.technicalStoreComparison' | translate}}
              </a>
            </li>
             -->
              <li>
                <a [routerLink]="['/reports/compare-prices']" routerLinkActive="active">
                  {{'header.priceIndex' | translate}}
                </a>
              </li>
            </ng-container>
          </ul>
          <ng-container *ngIf="!currentUser">
            <a class="icon login" [routerLink]="['/login']">
              <span>{{ "header.loginNew" | translate }}</span>
            </a>
            <a class="icon register m-0" [routerLink]="['/register']">
              <span>{{ "header.createAccount" | translate }}</span>
            </a>
          </ng-container>
          <ng-container *ngIf="currentUser">
            <a class="allSeenRights" [routerLink]="['home/allSeenRights']">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                <g id="Back_to_Search_Result" data-name="Back to Search Result" transform="translate(-1360)">
                  <circle id="circle" cx="24" cy="24" r="24" transform="translate(1360)" fill="#e4ebf0" />
                  <path id="ic_search_history"
                    d="M23.7,22.139l-2.683-2.666A5.942,5.942,0,0,0,22.142,16,6.036,6.036,0,1,0,19.6,20.887l2.683,2.666a1.011,1.011,0,0,0,1.423,0,.994.994,0,0,0,0-1.414ZM15.426,19a2.4,2.4,0,0,1-1.675-.674l-1.139-1.108A1,1,0,0,1,12.6,15.8a1.012,1.012,0,0,1,1.423-.016l1.139,1.108a.378.378,0,0,0,.525,0l2.73-2.624a1.012,1.012,0,0,1,1.423.029,1,1,0,0,1-.029,1.414l-2.72,2.614A2.371,2.371,0,0,1,15.425,19ZM8.052,16A8.046,8.046,0,0,1,20.129,9.083V5A5.023,5.023,0,0,0,15.1,0H5.031A5.022,5.022,0,0,0,0,5V19a5.023,5.023,0,0,0,5.032,5H16.1a8.035,8.035,0,0,1-8.052-8ZM10.064,5H15.1a1,1,0,1,1,0,2H10.064a1,1,0,1,1,0-2ZM6.039,17H5.032a1,1,0,1,1,0-2H6.039a1,1,0,1,1,0,2Zm0-5H5.032a1,1,0,1,1,0-2H6.039a1,1,0,1,1,0,2Zm0-5H5.032a1,1,0,1,1,0-2H6.039a1,1,0,1,1,0,2Z"
                    transform="translate(1372 12)" fill="#225c80" />
                </g>
              </svg>
            </a>

            <div class="elementor-widget-container">
              <div *ngIf="currentUser" class="userAccount dropdown-container m-0" id="userAccountDrop" appDropDown>
                <div class="dropdown-toggler d-flex align-items-center">
                  <div class="profile-image">
                    <img *ngIf="currentUser.ImagePath" [src]="currentUser.ImagePath"
                      (error)="currentUser.ImagePath = ''" />
                    <span *ngIf="!currentUser.ImagePath" [innerHTML]="currentUser.FullName | shortName"></span>
                  </div>
                  <div class="user-name">
                    <span class="mr-2"> <span>{{ 'general.Hello' | translate }}</span>, {{currentUser.FullName}}</span>
                  </div>
                </div>

                <div class="custom-dropdown-menu dropdown-inner-menu">
                  <ul>
                    <li><a [routerLink]="['user-profile']">
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="18" viewBox="0 0 13.5 18">
                            <path id="ic_user"
                              d="M.75,18A.75.75,0,0,1,0,17.25a6.75,6.75,0,1,1,13.5,0,.75.75,0,0,1-.75.75ZM2.25,4.5A4.5,4.5,0,1,1,6.75,9,4.5,4.5,0,0,1,2.25,4.5Z"
                              fill="#8E8FA2" />
                          </svg>
                        </span>
                        {{ 'profile.accountManagement' | translate }}
                      </a>
                    </li>
                    <li *ngIf="currentUser.UserType != 'CONSUMER'">
                      <a [href]="appRedirectUrl + '?refreshToken=' + currentUser.EncodedRefreshToken">
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="19.013" height="18.999"
                            viewBox="0 0 19.013 18.999">
                            <path id="ic_change_account"
                              d="M4.125,5.25A2.625,2.625,0,1,0,1.5,2.625,2.628,2.628,0,0,0,4.125,5.25Zm9,7.5A3.375,3.375,0,1,0,9.749,9.375,3.379,3.379,0,0,0,13.124,12.749Zm-6.8,1.205a1.492,1.492,0,0,1-.01,2.1L4.665,17.769a.75.75,0,1,1-1.081-1.039l.942-.98H3a3,3,0,0,1-3-3V12a.75.75,0,0,1,1.5,0v.75a1.5,1.5,0,0,0,1.5,1.5H4.521l-.937-.98a.75.75,0,0,1,1.081-1.04l1.659,1.726Zm11.644,3.082a5.085,5.085,0,0,0-9.688,0A.75.75,0,0,0,9,18h8.25a.749.749,0,0,0,.719-.961ZM4.125,6A4.333,4.333,0,0,0,.047,8.736.751.751,0,0,0,.75,9.75H7.5a.751.751,0,0,0,.7-1.013A4.331,4.331,0,0,0,4.125,6Z"
                              transform="translate(0.508 0.5)" fill="#8e8fa2" stroke="rgba(0,0,0,0)"
                              stroke-miterlimit="10" stroke-width="1" />
                          </svg>
                        </span>
                        {{ 'general.viewMyAccountAsSystemUser' | translate }}
                      </a>
                    </li>
                    <li>
                      <a (click)="logout()">
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                            <path id="ic_log_out"
                              d="M16173.752,16742a3.755,3.755,0,0,1-3.751-3.75v-10.5a3.755,3.755,0,0,1,3.751-3.75h1.5a.75.75,0,0,1,0,1.5h-1.5a2.251,2.251,0,0,0-2.251,2.25v10.5a2.251,2.251,0,0,0,2.251,2.25h1.5a.75.75,0,0,1,0,1.5Zm9.382-3.969a.75.75,0,0,1,.019-1.061l2.91-2.91a1.5,1.5,0,0,0,.25-.346.518.518,0,0,1-.059.012l-11.761.023a.75.75,0,0,1,0-1.5l11.766-.023c.011,0,.021.006.031.006a1.556,1.556,0,0,0-.225-.293l-2.91-2.908a.75.75,0,0,1,1.061-1.061l2.91,2.908h0a3,3,0,0,1,0,4.242l-2.91,2.91-.019.018a.75.75,0,0,1-1.061-.018Z"
                              transform="translate(-16169.501 -16723.502)" fill="#8e8fa2" stroke="rgba(0,0,0,0)"
                              stroke-miterlimit="10" stroke-width="1" />
                          </svg>
                        </span>
                        {{ 'general.logout' | translate }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </header>

  <div class="w-100">
    <div class="m-auto panel_container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <footer>
    <div class="bottom-footer">
      <p>©{{ "general.copyright" | translate }}</p>
    </div>
  </footer>
</div>